export function place_select_check(tableData, place_index) {
    tableData[place_index].check = !tableData[place_index].check
    return tableData
}